import { CSSProperties } from "react";
import { Button, Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const FormAddPlate = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: -22px;
  margin-bottom: -20px;

  .ant-form-item-label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 600;
    padding: 0;
  }

  .ant-form-item-control-input-content {
    color: ${(props) => props.theme["@primary-color-brand"]};
    display: flex;
  }
`;

export const FormItemTrailersPlates = styled(Item)`
  .ant-input {
    width: 120px;
    margin-left: 0;
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
  }
`;

export const VehicleInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 3px;
`;

export const FormItem = styled(Item)`
  margin-top: 15px;
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-form-item-label {
    text-align: start;
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content > textarea {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    &:hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    }
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }

  .ant-form-item-control-input-content > .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }

  .ant-form-item-control-input-content > textarea:hover:disabled {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }
`;

export const VehicleActionContainer = styled.div``;

export const RadioContainer = styled.div`
  height: 50px;
  margin: 10px -8px 0 -8px;
  .ant-radio-wrapper.ant-radio-wrapper-checked.radioButton {
    border: 2px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    border-radius: 4px;
  }
  .ant-radio-wrapper.radioButton {
    background-color: ${(props) => props.theme["@opacity-color-default-background"]};
    border: 1.6px solid ${(props) => props.theme["@box-shadow"]} !important;
    border-radius: 4px;
  }
  .ant-radio.ant-radio-checked {
    background-color: ${(props) => props.theme["@opacity-color-default-background"]} !important;
    margin-left: 8px;
    margin-top: -5px;
  }
  .ant-radio {
    margin-left: 8px;
    margin-top: -5px;
  }
  .radioButton {
    margin-left: 8px;
    align-items: center;
  }
`;

export const DescriptionVehicleAction = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin: 0;
`;

export const DriverWarningDescription = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin-top: 20px;
`;

export const DescriptionVehicleActionContainer = styled.div`
  text-align: center;
  margin-top: 45px;
`;

export const RadioGroup: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  height: theme["@height-input-lg"],
};

export const RadioOnlyOption: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr",
  height: theme["@height-input-lg"],
};

export const FormPlateItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-input-affix-wrapper > input.ant-input {
    text-transform: uppercase;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
    > span {
      pointer-events: auto;
    }
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:active,
    input:-webkit-autofill:focus {
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      color: ${(props) => props.theme["@secondary-color"]} !important;
      box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
      -webkit-box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
    }
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }
`;

export const InputCustomPlate = (plateFormatType?: 0 | 1 | 2): CSSProperties => ({
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
  width: plateFormatType === 1 ? "140px" : plateFormatType === 2 ? "130px" : "120px",
  padding: plateFormatType === 1 ? "0 12px" : "0 8px",
  letterSpacing: plateFormatType === 1 ? "1px" : "0.5px",
});

export const SpanForm: CSSProperties = {
  fontWeight: 300,
  fontFamily: theme["@font-family"],
};

export const TrailersPlatesField: CSSProperties = {
  textTransform: "uppercase",
  marginRight: "4px",
  height: "40px",
};

export const PlateField: CSSProperties = {
  width: "33%",
};

export const ShippingCompanyField: CSSProperties = {
  width: "100%",
};

export const DockDescriptionField: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  borderRadius: theme["@border-radius-base"],
};

export const ProcessesFormItem: CSSProperties = {
  width: "100%",
};

export const ProcessesSelectFormItem: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  marginBottom: "58px",
};

export const ProcessesSelect: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const FormItemRegisterButton: CSSProperties = {
  marginLeft: "171px",
};

export const InputPlate: CSSProperties = {
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
};

export const InputCarrier: CSSProperties = {
  height: theme["@height-input-lg"],
};

export const ButtonForm = styled.div`
  position: fixed;
  bottom: 0px;
  display: flex;
`;

export const AddButtonPlate = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  float: left;
  display: flex;
  margin-top: 26px;
  justify-content: center;
  color: ${(props) => props.theme.colors.manatee};

  .addButtonTrailersPlates {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const TitleForm: CSSProperties = {
  color: theme["@secondary-color"],
};

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: ${(props) => (props.hasEntryPermission ? "1fr 1px 1fr 1px 0.7fr" : "1fr 1px 1fr")};
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  .divider {
    background-color: ${(props) => props.theme["@input-border-color"]};
  }
`;

export const PlateContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FakeBtnConfirm = {
  display: "none",
};

export const Driver = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
  > label > span:nth-child(2) {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
`;

export const SaleChannelFormItem: CSSProperties = {
  width: "100%",
  marginTop: 0,
};

export const SaleChannelSelect: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
};
